import { render, staticRenderFns } from "./reprintbukusimpanan.vue?vue&type=template&id=1f764453"
import script from "./reprintbukusimpanan.vue?vue&type=script&lang=js"
export * from "./reprintbukusimpanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports